import React, { useState } from "react";
import { toast } from "react-toastify";
import { api } from "../../../config/api";
import { BackEndRoutes } from "../../../config/back-end-routes";

interface AddTableModalProps {
    onClose: () => void;
    onSuccess: () => void;
}

const AddTableModal: React.FC<AddTableModalProps> = ({ onClose, onSuccess }) => {
    const [description, setDescription] = useState("");
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");

    const handleSubmit = async () => {
        if (!description.trim()) {
            setError("A descrição é obrigatória.");
            return;
        }

        setError("");
        setLoading(true);

        try {
            await api.post(BackEndRoutes.routes.TABELA_PRECOS.LIST, {
                descricao: description,
                status: 1,
            });
            toast.success("Tabela adicionada com sucesso!");
            onSuccess();
            onClose();
        } catch (err) {
            console.error("Erro ao adicionar tabela:", err);
            toast.error("Erro ao adicionar tabela.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="modal" style={{ display: "block" }}>
            <div className="modal-dialog">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">Adicionar Nova Tabela</h5>
                        <button
                            type="button"
                            className="btn-close"
                            onClick={onClose}
                            disabled={loading}
                        ></button>
                    </div>
                    <div className="modal-body">
                        <div className="mb-3">
                            <label htmlFor="description" className="form-label">
                                Descrição <span className="text-danger">*</span>
                            </label>
                            <input
                                type="text"
                                id="description"
                                className={`form-control ${error ? "is-invalid" : ""}`}
                                placeholder="Digite a descrição da tabela"
                                value={description}
                                onChange={(e) => setDescription(e.target.value)}
                                disabled={loading}
                            />
                            {error && <div className="invalid-feedback">{error}</div>}
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button
                            className="btn btn-secondary"
                            onClick={onClose}
                            disabled={loading}
                        >
                            Cancelar
                        </button>
                        <button
                            className="btn btn-primary"
                            onClick={handleSubmit}
                            disabled={loading}
                        >
                            {loading ? "Salvando..." : "Salvar"}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AddTableModal;
